import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function createSelfRaiseEyeTicket(eyeTicket) {
    const url = '/SelfRaiseEyeTicket/CreateSelfRaiseTicket';

    try {
        const response = await buildRequest(url, 'POST', eyeTicket);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to create EyeTicket: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to create EyeTicket: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }

        if (response.ok && response.status === 200) {
            const barcodeMatch = text.match(/New EyeTicket ID \d+ raised successfully for barcode No\. (\d+)/i);
            if (barcodeMatch && barcodeMatch[1]) {
                return parseInt(barcodeMatch[1], 10);
            }

            const eyeTicketMatch = text.match(/New EyeTicket ID (\d+) raised successfully/i);
            if (eyeTicketMatch && eyeTicketMatch[1]) {
                return parseInt(eyeTicketMatch[1], 10);
            }
            throw new Error(`Failed to parse Barcode or EyeTicket ID from response: ${text}`);
        }

    } catch (error) {
        throw new Error(error.message);
    }
}


export async function authoriseSelfRaiseEyeTicket(eyeTicket, barcode, surname, action) {
    const url = `/SelfRaiseEyeTicket/AuthoriseSelfRaiseEyeTickets?cBarcode=${encodeURIComponent(barcode)}&cSurname=${encodeURIComponent(surname)}&cAction=${encodeURIComponent(action)}`;

    try {
        const response = await buildRequest(url, 'PUT', eyeTicket);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to authorise EyeTicket: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to authorise EyeTicket: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchFrames() {
    let url = `/SelfRaiseEyeTicket/GetFramesList`;
    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Frames found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Frames: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}